import { render, staticRenderFns } from "./letter-spacing.vue?vue&type=template&id=dd8e59d0&"
import script from "./letter-spacing.vue?vue&type=script&lang=js&"
export * from "./letter-spacing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports